if (typeof Plugin_Katastr === 'undefined') {

    var Plugin_Katastr = {

        kuAutocomplete: function() {

            var ku = $('#modal-katastralniuzemi');
            var kodKU = $('#modal-kodku');
            if(!ku.length) {
                return;
            }

            var url = window.location.protocol + '//' + window.location.host;
            url += '/plugin/PluginKatastr/ajaxSearchTerritoryByName';

            var modalWindow = $('[id^=modal-container-]').last();

            ku.autocomplete({
                autofocus: true,
                minLength: 0,
                source: function (request, response) {
                    $.ajax({
                        url: url,
                        dataType: 'json',
                        data: $(modalWindow).find('form').serialize(),
                        type: 'post',
                        beforeSend: function() {
                            kodKU.val('');
                        },
                        success: function (r) {

                            if(r.hasOwnProperty('messages')) {
                                Lemo_Alert.addMany(r.messages);
                            }

                            if(r.hasOwnProperty('status') && true === r['status']) {
                                if(r.hasOwnProperty('data')) {
                                    response(r['data']);
                                    var items = r['data'];
                                    if(!items.length) {
                                        Lemo_Alert.addDanger('Katastrální území nebylo nalezeno', 'searchTerritoryError');
                                    }
                                }
                            }
                        }
                    })
                },
                select: function(e, ui)  {
                    e.preventDefault();
                    if(ui.hasOwnProperty('item')) {
                        var item = ui.item;
                        if(item.hasOwnProperty('id') && item.hasOwnProperty('label')) {
                            kodKU.val(item.id);
                            ku.val(item.label);
                        }
                    }
                }
            });
        },

        searchTerritory: function() {

            var ku = $('#modal-katastralniuzemi');
            var kodKU = $('#modal-kodku');
            if(!ku.length || !kodKU.length || '' === kodKU.val()) {
                return;
            }

            var url = window.location.protocol + '//' + window.location.host;
            url += '/plugin/PluginKatastr/ajaxSearchTerritoryByCode';

            var modalWindow = $('[id^=modal-container-]').last();

            $.ajax({
                type: 'post',
                url: url,
                dataType: "json",
                data: $(modalWindow).find('form').serialize(),
                global: false,
                beforeSend: function() {
                    Lemo_Alert.addInfo('Vyhledávám katastrální území ...', 'searchTerritoryBeforeSend');
                    ku.val('');
                },
                complete: function() {
                    Lemo_Alert.closeById('searchTerritoryBeforeSend');
                },
                success: function(r) {

                    if(r.hasOwnProperty('messages')) {
                        Lemo_Alert.addMany(r.messages);
                    }

                    if(r.hasOwnProperty('status') && true === r['status']) {
                        if(r.hasOwnProperty('data')) {
                            var data = r['data'];
                            if(data.length) {
                                ku.val(data[0].label);
                            } else {
                                Lemo_Alert.addDanger('Nebylo nalezeno odpovídající katastrální území', 'searchTerritoryError');
                            }
                        }
                    }
                },
                error: function() {
                    Lemo_Alert.addDanger('Vyhledání katastrálního území selhalo ...', 'searchTerritoryError');
                }
            });
        },

        init: function() {

            var kodKU = $('#modal-kodku');
            var ku = $('#modal-katastralniuzemi');
            var cisloParcely = $('#modal-cisloparcely');
            var podCisloParcely = $('#modal-podcisloparcely');

            if (kodKU.length && ku.length && cisloParcely.length && podCisloParcely.length) {

                Plugin_Katastr.kuAutocomplete();

                kodKU.on('input change', function () {
                    Plugin_Katastr.searchTerritory();
                });

                cisloParcely.on('change', function () {
                    podCisloParcely.val('');
                });

                podCisloParcely.on('change', function () {

                });
            }
        }
    }
}

$(document)
    .ready(function () {
        $(document)
            .on('modal.miniform.item.add.build', function() {Plugin_Katastr.init()})
            .on('modal.miniform.item.edit.build', function() {Plugin_Katastr.init()});
    });
